<div class="app__discovery--widget--container">
  <div class="app__itemCard-radioGroup app__sub-title items-start text-[#53565B] font-semibold mt-5 m-0 px-2">
    <p [innerHTML]="mainTitle"></p>
  </div>
  <div class="app__discovery--inner--section">
    @for (instruction of instructions; track instruction; let last = $last) {
      <div class="app__discovery--instructions--card mt-3" [ngClass]="!last ? 'mb-2' : ''">
        <div class="flex">
          <span class="min-w-[13%]"> <img [src]="'assets/images/instructions/instruction_icon_' + instruction?.imageNumber + '.svg'" /></span>
          <div class="app__styled--unordered-list">
            <p class="app__form--attribute--title text-[17px] leading-[26px] text-left">
              {{ instruction?.title }}
            </p>
            @for (item of instruction.instructionLists; track item; let index = $index) {
              <ul class="m-0 px-0 pl-[24px]" [ngClass]="!last ? ' mb-[6px]' : ''">
                <li class="app__sub-title text-left text-sm text-[#515765] leading-[29px]" [innerHTML]="item"></li>
              </ul>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>

<mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
<div class="flex items-start justify-end w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
  <!-- <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
  <span class="app__centered-item gap-2 text-[#18191C]"
    ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
    >
  </button> -->
  <div class="w-[158px]">
    <button
      class="app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
      type="submit"
      (click)="handleSteps('forward')"
      >
      Continue
    </button>
  </div>
</div>
